import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "fontsource-roboto";
import "./index.css";
import configureStore, { history } from "./store/configureStore";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import loadInitialData from "./store/load_initial_data";
import { initializeFirebase } from "./services/firebase";
import { initializeLocalforage } from "./services/localstorage_service";
import "./services";
// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: '' });
//const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

loadInitialData(store);
//const rootElement = document.getElementById("root");

initializeFirebase();
initializeLocalforage();

//<React.StrictMode>
ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
